import { useState } from 'react';
import { InvoiceListItem } from '../../../../redux/accounting/definitions';

type UseInvoiceListSelection = {
  selectedInvoices: InvoiceListItem[];
  showModal: boolean;
  openModal: () => void;
  closeModal: () => void;
  addSelectedInvoices: (invoices: InvoiceListItem | InvoiceListItem[]) => void;
  removeSelectedInvoices: (invoice_ids: number[]) => void;
};

const useInvoiceListSelection = (): UseInvoiceListSelection => {
  const [selectedInvoices, setSelectedInvoices] = useState<InvoiceListItem[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);

  const addSelectedInvoices = (invoices: InvoiceListItem | InvoiceListItem[]) => {
    if (Array.isArray(invoices)) {
      setSelectedInvoices(invoices);
    } else {
      setSelectedInvoices([invoices]);
    }
  };

  const removeSelectedInvoices = (invoice_ids: number[]) => {
    setSelectedInvoices(selectedInvoices.filter((invoice: InvoiceListItem) => !invoice_ids.includes(invoice.id)));
  };

  const openModal = (): void => {
    if (selectedInvoices.length > 0) setShowModal(true);
  };

  const closeModal = (): void => {
    setShowModal(false);
  };

  return {
    showModal,
    selectedInvoices,
    openModal,
    closeModal,
    addSelectedInvoices,
    removeSelectedInvoices,
  };
};

export default useInvoiceListSelection;
